
import axios from 'axios';
import config from '../config';
import {handlingSession,sessionID} from './../../utils/handlingSession'
import {userLogs} from './../logs/userLogs'


export const getPartnerSearch = (formData) => {

    if(formData.Industry!=''){
        const data =formData.Industry.replaceAll(",~",'~>');
        if(data.includes('~')){
            formData.Industry=data.substring(1);
        }else{
            formData.Industry = data;
        }
    }

    if(formData.Location!=''){
        const LocationData =formData.Location.replaceAll(",~",'~>');
        if(LocationData.includes('~')){
            formData.Location=LocationData.substring(1);
        }else{
            formData.Location = LocationData;
        }
    }
    let url = config.hummBackendAppURL+'partner/Partner-filter'
    return async (dispatch) => {
        let partnerSearchResponse=[];
        await axios.post(url,  formData,{headers:sessionID()} )
            .then(response => {
                dispatch({
                    type: 'PARTNER_SEARCH_LIST',
                    value: response.data
                });
                
                partnerSearchResponse = response;
                return partnerSearchResponse;
            })
            .catch(async error => {
                await userLogs(url,formData,error);
                if(error.response){
        handlingSession(error.response.status);
        }
                partnerSearchResponse = error.response;
                return partnerSearchResponse;
            })
            return partnerSearchResponse;
    }
};
